import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,[_c(VCol,{attrs:{"md":"6"}},[_c('Info'),_c('Config'),_c('UpdatePassword')],1),_c(VCol,{attrs:{"md":"6"}},[_c('Departments'),_c('Initiator'),_c('Units')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }